import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M24 4C24 3.4475 23.5525 3 23 3H10V13H0V20C0 20.5525 0.4475 21 1 21H23C23.5525 21 24 20.5525 24 20V4Z',
                    fill: '#B41F30',
                },
            },
            { tag: 'path', attr: { d: 'M24 5H10V7H24V5Z', fill: '#E6E6E6' } },
            { tag: 'path', attr: { d: 'M24 9H10V11H24V9Z', fill: '#E6E6E6' } },
            { tag: 'path', attr: { d: 'M0 13V15H24V13H10H0Z', fill: '#E6E6E6' } },
            { tag: 'path', attr: { d: 'M24 17H0V19H24V17Z', fill: '#E6E6E6' } },
            {
                tag: 'path',
                attr: { d: 'M10 13H0V4C0 3.4475 0.4475 3 1 3H10V13Z', fill: '#00256A' },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M5.00014 6.96094L4.68364 7.64494H3.93164L4.48164 8.21494L4.27864 9.03894L5.00014 8.62994L5.72164 9.03894L5.51864 8.21494L6.06864 7.64494H5.31564L5.00014 6.96094Z',
                    fill: 'white',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M2.55335 4.51453L2.23735 5.19853H1.48535L2.03485 5.76853L1.83185 6.59253L2.55335 6.18353L3.27535 6.59253L3.07185 5.76853L3.62185 5.19853H2.86885L2.55335 4.51453Z',
                    fill: 'white',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M7.44643 4.51453L7.76243 5.19853H8.51443L7.96493 5.76853L8.16793 6.59253L7.44643 6.18353L6.72443 6.59253L6.92793 5.76853L6.37793 5.19853H7.13093L7.44643 4.51453Z',
                    fill: 'white',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M2.55335 11.4855L2.23735 10.8015H1.48535L2.03485 10.2315L1.83185 9.40747L2.55335 9.81647L3.27535 9.40747L3.07185 10.2315L3.62185 10.8015H2.86885L2.55335 11.4855Z',
                    fill: 'white',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M7.44643 11.4855L7.76243 10.8015H8.51443L7.96493 10.2315L8.16793 9.40747L7.44643 9.81647L6.72443 9.40747L6.92793 10.2315L6.37793 10.8015H7.13093L7.44643 11.4855Z',
                    fill: 'white',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const UsaColored = React.forwardRef(IconComponent);
UsaColored.displayName = 'UsaColored';

export { UsaColored };
